import React from "react"
import Layout from "../components/layout"
import SEO from '../components/seo'
import styled from "@emotion/styled"
import { graphql } from 'gatsby'
import Img from 'gatsby-image'
import CheckoutButton from "../components/checkout"



const BookContainer = styled.div`
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    max-width: 1000px;
    margin: 0 auto;
    margin-top: 8rem;
    margin-bottom: 5rem;

    @media (max-width: 1200px) {
       max-width: 900px;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
    }
`

const BookCoverContainer = styled.div`
    width: 50%;

    @media (max-width: 1200px) {
        width: 45%
    }

    @media (max-width: 768px) {
        width: 60%;
    }

    @media (max-width: 425px) {
        width: 70%;
    }
`

const BookInfoContainer = styled.div`
    width: 50%;

    @media (max-width: 1200px) {
       width: 55%;
    }

    @media (max-width: 768px) {
        width: 80%;
        text-align: center;
    }

    @media (max-width: 425px) {
        width: 88%;
        margin: 2rem 1rem;;
    }
`

const BookTitle = styled.h2`
    font-size: 2rem;

    @media (max-width: 425px) {
        font-size: 1.75rem;
    }
`

const BookDescription = styled.p`
    font-size: 1.2rem;
    line-height: 1.75rem;

    @media (max-width: 425px) {
        font-size: 1.3rem;
        line-height: 1.85rem;
    }
`


function BookPage(props) {
    return (
        <div>
            <SEO title="Book" />
            <Layout>
                <BookContainer>
                    <BookCoverContainer>
                        <Img fluid={props.data.bookImgOne.childImageSharp.fluid} alt="Me and Bobby McGee Book Cover" />
                    </BookCoverContainer>
                    <BookInfoContainer>
                        <BookTitle>Me &amp; Bobby McGee</BookTitle>
                        <BookDescription>Get ready to laugh and cry your way through Janis Byrne's audacious story. 
                            A heartwarming true story about a young runaway seeking a new life and an identity all her own. 
                            With the help of a spunky dalmatian named Bobby, Janis braves unpredictable and often dangerous roads from California to Florida.<br/><br/>
                            It sometimes takes 3,000 miles and the adventure of a lifetime to learn that we are much more than our past, and the best helping hands sometimes don't even have thumbs.</BookDescription>
                        <CheckoutButton />
                    </BookInfoContainer>
                </BookContainer>
            </Layout>
        </div>
    )
}

export default BookPage

export const query = graphql`
query {
  bookImgOne: file(relativePath: { eq: "book-mockup.png" }) {
    childImageSharp {
      fluid(maxWidth: 1200, quality: 100) {
        ...GatsbyImageSharpFluid
        presentationWidth
      }
    }
  }
}
`